import Drawer from '@material-ui/core/Drawer';
import withStyles from '@material-ui/core/styles/withStyles';

export const DrawerBox = withStyles({
  paper: {
    zIndex: 999999,
    maxWidth: '100%',
  },
})(Drawer);
